module.exports = __webpack_public_path__ + "static/media/lease1.b961375f.svg";